var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4",class:_vm.componentConfig.class},[_c('div',{staticClass:"text-center text-grey-2 text-lg px-6"},[_vm._v(_vm._s(_vm.finalTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }